import type { ConflictChoice } from './types';

export const CHANGE_TYPE_LABEL: Record<string, string> = {
  CREATE: 'Created',
  UPDATE: 'Updated',
  DELETE: 'Deleted',
  REORDER: 'Reordered',
};

export const RESOLUTION_KEEP: ConflictChoice = 'keep';
export const RESOLUTION_OVERRIDE: ConflictChoice = 'override';

/** Rows per page on the Incoming / Outgoing promotion tables. `SortableTable` paginates client-side once a
 * list reaches twice this (both list endpoints return every row; a target org accumulates one per
 * promotion, so the lists only grow). */
export const PROMOTIONS_ROWS_PER_PAGE = 20;
